@if (bookingAvailabilities.length > 0) {
  <div class="availability-wrapper" [class.align-self-end]="(inputMessage() | messageStatusType) === 'sent'">
    @for (availability of bookingAvailabilities; track $index) {
      <button mat-flat-button (click)="setPreferredBooking(availability)">
        {{ availability.displayText }}
      </button>
    }
  </div>
}
